import { DateTime } from "luxon";
import { FShift, FShiftForDay, Marker } from "../types/types";
import { Exclude } from "../stores/TabsStore";


export const getPerfectDateTime = (date: string) => {
  return `${new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate()}.${
    new Date(date).getMonth() < 9 ? "0" + (new Date(date).getMonth() + 1) : new Date(date).getMonth() + 1
  }.${new Date(date).getFullYear()} ${
    new Date(date).getHours() < 10 ? "0" + new Date(date).getHours() : new Date(date).getHours()
  }:${new Date(date).getMinutes() < 10 ? "0" + new Date(date).getMinutes() : new Date(date).getMinutes()}`;
};

export const getPerfectDate = (value: any) => {
  let date;
  if (typeof value == "number") {
    date = value - convertTimezone(value);
  } else {
    date = new Date(value).getTime() - convertTimezone(new Date(value).getTime());
  }

  return `${new Date(date).getDate() < 10 ? "0" + new Date(date).getDate() : new Date(date).getDate()}.${
    new Date(date).getMonth() < 9 ? "0" + (new Date(date).getMonth() + 1) : new Date(date).getMonth() + 1
  }.${new Date(date).getFullYear()}`;
};

const convertTimezone = (date: any) => {
  const localTz = new Date(date).getTimezoneOffset();
  const siteTz = DateTime.fromMillis(date).offset;

  return (siteTz + localTz) * 60000;
};

export const convertTimeToSeconds = (time: string) => {
  if (!time) {
    return 0;
  }
  const a = time.split(":");
  const seconds = +a[0] * 60 * 60 + +a[1] * 60 + +a[2];
  return seconds;
};

export const convertDate = (timeInSeconds: number) => {
  const t = timeInSeconds * 1000;
  return `${new Date(t).getDate()}.${new Date(t).getMonth() + 1}.${new Date(t).getFullYear()}`;
};

export const getDayTimeDiff = (timeInISOString: string) => {
  const dayTimeDiff =
    DateTime.fromISO(timeInISOString).toSeconds() -
    DateTime.fromISO(timeInISOString).startOf("day").toSeconds();
  
  return dayTimeDiff;
}

export const secondsToTime = (timeInSeconds: any) => {
  var sec_num = parseInt(timeInSeconds, 10);
  var hours = Math.floor(sec_num / 3600);
  var minutes = Math.floor((sec_num - hours * 3600) / 60);
  var seconds = sec_num - hours * 3600 - minutes * 60;

  if (hours < 10) {
    //@ts-ignore
    hours = "0" + hours;
  }
  if (minutes < 10) {
    //@ts-ignore
    minutes = "0" + minutes;
  }
  if (seconds < 10) {
    //@ts-ignore
    seconds = "0" + seconds;
  }
  //@ts-ignore
  if (timeInSeconds < 0 || timeInSeconds == undefined || timeInSeconds == null) {
    return "00:00:00";
  } else {
    return hours + ":" + minutes + ":" + seconds;
  }
};

export const convertTime = (timestamp: number) => {
  if (timestamp < 0 || timestamp == undefined || timestamp == null) {
    return "00:00:00";
  } else {
    return DateTime.fromSeconds(timestamp).toFormat("HH:mm:ss");
  }
};

export function groupBy(list: any[], keyGetter: (arg0: any) => any) {
  const map = new Map();
  list.forEach((item) => {
    const key = keyGetter(item);
    const collection = map.get(key);
    if (!collection) {
      map.set(key, [item]);
    } else {
      collection.push(item);
    }
  });
  return Array.from(map.entries());
}

export const groupByKeys =
  <T>(keys: (keyof T)[]) =>
  (array: T[]): Record<string, T[]> =>
    array.reduce((objectsByKeyValue, obj) => {
      const value = keys.map((key) => obj[key]).join("-");
      objectsByKeyValue[value] = (objectsByKeyValue[value] || []).concat(obj);
      return objectsByKeyValue;
    }, {} as Record<string, T[]>);

export function getMarkersFromExcludes(excludes: Exclude[]) {
  if(!excludes || excludes.length === 0) { return []}

  let markersData: Marker[] = []
  excludes.map((e: any) => {
    markersData.push({time: e?.exclude_start} as Marker)
    markersData.push({time: e?.exclude_end} as Marker)
  })
  return markersData
}

export function convertFShiftToFShiftForDay(shift: FShift, date: DateTime | null):FShiftForDay {
  let transitiveShift = shift.start_at > shift.end_at
  if(transitiveShift) {
    if(!date) {
      if(DateTime.local() > DateTime.local().set({hour: shift.start_at.hour, minute: shift.start_at.minute}) && DateTime.local() < DateTime.local().endOf('day')) {
        return {...shift, start_day: DateTime.local(), end_day: DateTime.local().plus({days: 1})}
      } else {
        return {...shift, start_day: DateTime.local().minus({days: 1}), end_day: DateTime.local()}
      }
    } else {
      return {...shift, start_day: date, end_day: date.plus({days: 1})}
    }
  } else {
    if(!date) {
      return {...shift, start_day: DateTime.local(), end_day: DateTime.local()}
    } else {
      return {...shift, start_day: date, end_day: date}
    } 
  }
}